import { OlympusClient } from '@/OlympusClient'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

import emailBuilderModule from '../../store'
import {
  type CampaignResource,
  type EmailSection,
  type EmailSectionCreate,
} from '../../types'

const LOCATION_SCOPED_FRANCHISEE_OTC_FLAG = 'hermes.locationScopedFranchiseeOtc'

export const createBlockHandler = async <
  TSection extends EmailSection,
  TSectionCreate extends EmailSectionCreate,
>(
  createData: TSectionCreate
): Promise<TSection> => {
  const currentResource = emailBuilderModule?.getters?.currentResource as
    | CampaignResource
    | undefined

  if (!currentResource) {
    throw new Error(
      'createBlockHandler (email): emailBuilderModule.getters.currentResource is undefined — wizard must call loadPreview before creating blocks'
    )
  }

  const { brandId, locationId } = currentResource
  const flagEnabled = useFeatureFlags().isEnabled(
    LOCATION_SCOPED_FRANCHISEE_OTC_FLAG
  )
  const fallbackLocationId = flagEnabled ? (locationId ?? null) : null

  return (await OlympusClient.notifications.v1.templates.emails.sections.createEmailSection(
    {
      body: {
        brandId,
        locationId: fallbackLocationId,
        ...createData,
      },
    }
  )) as TSection
}
